<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="makeCampaign">
              캠페인생성
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="캠페인명" label-width="100px">
                <el-input v-model="search.campaignNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="시작일자" label-width="100px">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker type="date" placeholder="시작일" v-model="search.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                  <el-col :span="1" style="text-align: start;">-</el-col>
                  <el-col :span="12">
                    <el-date-picker type="date" placeholder="종료일" v-model="search.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="상태" label-width="80px">
                <el-col>
                  <el-select v-model="search.campaignStatus">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['campaignStatus']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">{{ item.value }}
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                row-selection="single"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"
                />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
/**
 * * Modal
 */


function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}


export default {
  props: {
  },
  data() {
    return {
      data: [],
      search: {
        companyId : '',
        campaignNm: '', // 캠페인명
        startDt: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        campaignStatus: '', // 상태
        campaignType: '', 
        sortType :  '',
        processTime : '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime: ''
      },
      combos: {
          'campaignStatus' : []
      },
      
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 20px; width: 100%;height: 550px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:false
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.createMainColumnDefs();
      this.getCombo({callBy : 'INIT'});
    },
    getCheckReadOnly(params){
      const vAsStatus = params.data.asStatus;
      // console.log('getCheckReadOnly aaa: ', vAsStatus, params)
      // K일때만 활성화
      if(vAsStatus === 'K'){
        return false;
      } else {
        return true;
      }
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {headerName:'캠페인번호', field:'campaignId', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'캠페인명', field:'campaignNm', width:150, cellStyle:{textAlign: 'left'}},
        {headerName:'시작일자', field:'startDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'종료일자', field:'endDt', width:210, cellStyle:{textAlign: 'center'}},
        {headerName:'상태', field:'campaignStatus', width:150, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'상태', field:'campaignStatusNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName: '선택', headerClass: 'header-rowspan-2',
            children: [{
                headerName: '수정',
                field: 'guaranteeStartDt',
                headerClass: 'hide-cell',
                width: 110,
                editable: true,
                cellRenderer: 'button',
                cellRendererParams: {
                    name:  '수정',
                    onClick: 'onEditButton01Click',
                    showButFlag: 'HAPPYCALL_MANAGER'
                }
            },{
                headerName: '대상',
                field: 'guaranteeEndDt',
                headerClass: 'hide-cell',
                width: 110,
                editable: true,
                cellRenderer: 'button',
                cellRendererParams: {
                    name:  '대상',
                    onClick: 'onEditButton02Click',
                    showButFlag: 'HAPPYCALL_MANAGER'
                }
            },{
                headerName: '분배',
                field: 'guaranteeEndDt',
                headerClass: 'hide-cell',
                width: 110,
                cellRenderer: 'button',
                cellRendererParams: {
                    name:  '분배',
                    onClick: 'onEditButton03Click',
                    showButFlag: 'HAPPYCALL_MANAGER'
                }
            }]
        }
      ];
    },
    
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    goOpen() {
      const vm = this;
      const vform = {
        ...this.search
      };

      console.log('goOpen passed this.form: ', vform);
      this.$store.commit('loading');

      this.$http.post(_url("/api/workMng/happyCallManager/list"), vform).then(response => {
        console.log('response.data' , response.data);
        vm.data = response.data.map(x=>{
          x.startDt = x.startDt && x.startDt.length>=10 ? x.startDt.substring(0,10) : '';
          x.endDt = x.endDt && x.endDt.length>=10 ? x.endDt.substring(0,10) : '';
          const vCampaignStatus = vm.combos['campaignStatus'].filter(y=>y.key===x.campaignStatus);

          if(vCampaignStatus && vCampaignStatus.length>0){
            x.campaignStatus = vCampaignStatus[0].key;
            x.campaignStatusNm = vCampaignStatus[0].value;
          }
          
          return x;
        });

      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    makeCampaign(){
      // 캠페인 생성
      
      this.$router.push({          
            name: 'HappycallInfoTab',
            params: {
              tabId: 'subTab1',
              detailLinkYn: 'N', /** 상세페이지 링크 클릭여부 : 입력/수정 구분하기위해 */
              campaignId: '',
              startDt: this.search.startDt,
              endDt: this.search.endDt
            }
        });

    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    async getCombo(param){

      if(param.callBy === 'INIT'){
        // 상태 : 해피콜진행상태
        await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 395}})
          .then(response => {
              this.combos['campaignStatus'] = response.data || []
          })
          .finally(() => {
            this.goOpen();
          });

      }  
      
    },
    onEditButton01Click(params){
      this.onEditButtonClick(params, 'subTab1');
    },
    onEditButton02Click(params){
      this.onEditButtonClick(params, 'subTab2');
    },
    onEditButton03Click(params){
      this.onEditButtonClick(params, 'subTab3');
    },
    onEditButtonClick(params, vTabId){
      console.log('onEditButtonClick params: ', params);

      let vName = 'HappycallInfoTab';
      if(vTabId === 'subTab2'){
        vName = 'HappycallCustTab';
      } else if(vTabId === 'subTab3'){
        vName = 'HappyCallDistribution';
      }
        
      this.$router.push({          
            name: vName,
            params: {
              tabId: vTabId,
              detailLinkYn: 'Y', /** 상세페이지 링크 클릭여부 : 입력/수정 구분하기위해 */
              campaignId: params.campaignId,
              startDt: this.search.startDt,
              endDt: this.search.endDt
            }
        });
    }

  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    console.log('search', this.search);
    // this.form.companyId = this.$store.state.loginInfo.compCd;

    // 상세화면에서 뒤로가기 클릭하여 온경우 다시 조회조건 셋팅
    if(this.$route.params.searchCond){
      const vBackObj = this.$route.params.searchCond;

      this.search.campaignNm = vBackObj.campaignNm ? vBackObj.campaignNm : '';
      this.search.startDt = vBackObj.startDt ? vBackObj.startDt : '';
      this.search.endDt = vBackObj.endDt ? vBackObj.endDt : '';
      this.search.campaignStatus = vBackObj.campaignStatus ? vBackObj.campaignStatus : '';
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>